import { render, staticRenderFns } from "./DisciplinaryViolationDelete.vue?vue&type=template&id=d42a0bc4"
import script from "./DisciplinaryViolationDelete.vue?vue&type=script&lang=js"
export * from "./DisciplinaryViolationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports